<template>
    <v-main class="lyt-container pt-3 justify-center custom-main">
        <router-view class="lyt-content"></router-view>
        <v-bottom-navigation class="lyt-menu">
            <v-btn
                v-if="adminVisible"
                class="lyt-menu__button"
                @click="$router.push({ name: 'Admin - Alumnos' })"
            >
                <span>Home</span>
                <i class="fas fa-home"></i>
            </v-btn>

            <v-btn
                v-if="prepVisible"
                class="lyt-menu__button"
                @click="$router.push({ name: 'prep' })"
            >
                <span>PREP</span>
                <i class="fa fa-chart-bar"></i>
            </v-btn>
            <v-btn
                v-if="prepVisible"
                class="lyt-menu__button"
                @click="$router.push({ name: 'resultados' })"
            >
                <span>Resultados</span>
                <i class="fa fa-chart-pie"></i>
            </v-btn>
            <v-btn
                v-if="prepPlanillasVisible"
                class="lyt-menu__button"
                @click="$router.push({ name: 'planillas' })"
            >
                <span>Planillas</span>
                <i class="fas fa-file-alt"></i>
            </v-btn>
            <v-btn
                v-if="tablesVisible"
                class="lyt-menu__button"
                @click="$router.push({ name: 'Mesas' })"
            >
                <span>Mesas</span>
                <img src="../assets/icn_voto_mesas.svg" />
            </v-btn>

            <v-btn class="lyt-menu__button" @click="logout">
                <span>Salir</span>
                <i class="fa fa-sign-out-alt"></i>
            </v-btn>
        </v-bottom-navigation>
    </v-main>
</template>

<script>
import { mapGetters } from 'vuex';
import {
    ADMIN_TYPE,
    FUNCIONARIO_TYPE,
    SECRETARIA_TYPE,
    SUBCOMISION_TYPE,
    HELPDESK_TYPE,
} from '@/helpers/roleTypes';

export default {
    computed: {
        ...mapGetters({
            user: 'user',
        }),
        mode() {
            return _.get(this, '$store.getters.user.mode');
        },
        adminVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE].includes(
                this.mode
            );
        },
        auditoriaVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        prepVisible() {
            return [ADMIN_TYPE, SECRETARIA_TYPE].includes(this.mode);
        },
        tablesVisible() {
            return [
                ADMIN_TYPE,
                SECRETARIA_TYPE,
                FUNCIONARIO_TYPE,
                SUBCOMISION_TYPE,
            ].includes(this.mode);
        },
        prepPlanillasVisible() {
            return [HELPDESK_TYPE].includes(this.mode);
        },
    },
    data: function() {
        return {
            ADMIN_TYPE,
            FUNCIONARIO_TYPE,
            SECRETARIA_TYPE,
        };
    },
    methods: {
        logout() {
            this.$store.dispatch('logout');
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-main :host ::ng-deep .v-main__wrap {
    justify-content: center;
    display: flex;
}

.lyt-container {
    background-image: url('../assets/bg_udg.png');
    background-color: $votex-background-primary;
}

.content {
	padding: 12px !important;
	margin-right: auto!important;
	margin-left: auto!important;
}

.lyt-content {
    margin-bottom: 64px;
}

.lyt-menu {
    bottom: 0;
    position: absolute !important;

    &__button {
        img {
            height: 32px;
            width: 32px;
        }

        svg {
            height: 32px;
            width: 32px;
            padding: 4px;
        }
    }
}
</style>
